import Jed from 'jed';
import store from 'store';
import {SET_CALENDAR_LOCALE_PARAMS} from 'store/modules/params/params';
import {isCurrentAppSeller} from 'utils/appTypeState';

class Index {

  constructor () {
    this.jed = null;
    this.helpJed = null;
    this.dateFormatter = null;
    this.numeralDelimeters = null;
  }

  async loadi18n (lang) {
    let langDeps = [
      import(

        /* webpackChunkName: "app-translations" */
        /* webpackMode: "lazy" */
        // eslint-disable-next-line prefer-template
        'translation/app/' + lang + '.json'
      ),

      // custom date formatter
      import(

        /* webpackChunkName: "momentcustom-translations" */
        /* webpackMode: "lazy" */
        // eslint-disable-next-line prefer-template
        'translation/moment/custom/' + lang + '.js'
      ),
      import(

        /* webpackChunkName: "autonumeric-translations" */
        /* webpackMode: "lazy" */
        // eslint-disable-next-line prefer-template
        'translation/autonumeric/custom/' + lang + '.js'
      ),

      import(

        /* webpackChunkName: "calendar-settings" */
        /* webpackMode: "lazy" */
        // eslint-disable-next-line prefer-template
        'translation/calendar/' + lang + '.js'
      )
    ];

    // english is default language
    if (lang !== 'en' && !isCurrentAppSeller()) {
      langDeps = langDeps.concat([
        import(

          /* webpackChunkName: "moment-translations" */
          /* webpackMode: "lazy" */
          // eslint-disable-next-line prefer-template
          'translation/moment/' + lang),
        import(

          /* webpackChunkName: "datepicker-translations" */
          /* webpackMode: "lazy" */
          // eslint-disable-next-line prefer-template
          'translation/jquery/ui.datepicker/' + lang),
        import(

          /* webpackChunkName: "timepicker-translations" */
          /* webpackMode: "lazy" */
          // eslint-disable-next-line prefer-template
          'translation/jquery/ui.timepicker/' + lang)
      ]);
    }

    return Promise.all(langDeps);
  }

  loadHelp (lang) {
    return import(

      /* webpackChunkName: "help-translation" */
      /* webpackMode: "lazy" */
      // eslint-disable-next-line prefer-template
      'help/' + lang + '.json'
    );
  }

  async initTranslations (lang) {
    const helpData = await this.loadHelp(lang);
    this.helpJed = new Jed({locale_data: {messages: helpData}});

    const values = await this.loadi18n(lang);

    const messages = values[0].default;
    this.dateFormatter = values[1].default;
    this.numeralDelimeters = values[2].default;
    const calendarParams = values[3].default;

    this.jed = new Jed({locale_data: {messages}, domain: 'messages'});
    if (!isCurrentAppSeller()) {
      await store.dispatch(`params/${SET_CALENDAR_LOCALE_PARAMS}`, calendarParams);
    }
  }

  fallback (text) {
    console.warn('Translation has not been initialized');
    return text;
  }

  tr (text) {
    if (!this.jed) {
      return this.fallback(text);
    }
    return this.jed.translate(text).fetch();
  }

  trc (context, text) {
    if (!this.jed) {
      return this.fallback(text);
    }
    return this.jed.translate(text).withContext(context).
      fetch();
  }

  ngettext (sing, plural, n) {
    if (!this.jed) {
      return this.fallback(sing);
    }
    return this.jed.translate(sing).ifPlural(n, plural).
      fetch(n);
  }

  helpFor (context, text) {
    if (!this.jed) {
      return this.fallback(text);
    }
    return this.helpJed.translate(text).withContext(context).
      fetch();
  }
}


export default new Index();
